import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_APPLICANT, DELETE_APPLICANT, UPDATE_APPLICANT, ADD_NEW_APPLICANT, GET_APPLICANT_ONE } from "./actionType";

import { getApplicantSuccess, getApplicantFail, deleteApplicantSuccess, deleteApplicantFail, updateApplicantSuccess, updateApplicantFail, addApplicantSuccess, addApplicantFail } from "./action";

//Include Both Helper File with needed methods
import { approveApplicantApi, getApplicantApi, updateApplicantApi, deleteApplicantApi, addNewApplicantApi, getOneApplicantApi } from "../../helpers/backend_helper";

function* getApplicant({ payload: applicant }) {
  try {
    const response = yield call(getApplicantApi, applicant);
    yield put(getApplicantSuccess(GET_APPLICANT, response.data));
  } catch (error) {
    yield put(getApplicantFail(GET_APPLICANT, error));
  }
}

function* getApplicantOne({ payload: id }) {
  try {
    const response = yield call(getOneApplicantApi, id);
    yield put(getApplicantSuccess(GET_APPLICANT_ONE, response));
  } catch (error) {
    yield put(getApplicantFail(GET_APPLICANT_ONE, error));
  }
}

function* onUpdateApplicant({ payload: applicant }) {
  try {
    if (applicant.setApprove) {
      const response = yield call(approveApplicantApi, applicant);
      yield put(updateApplicantSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateApplicantApi, applicant);
      yield put(updateApplicantSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateApplicantFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteApplicant({ payload: applicant }) {
  try {
    const response = yield call(deleteApplicantApi, applicant);
    yield put(deleteApplicantSuccess({ applicant, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteApplicantFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewApplicant({ payload: applicant }) {
  try {
    const response = yield call(addNewApplicantApi, applicant);
    yield put(addApplicantSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addApplicantFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetApplicant() {
  yield takeEvery(GET_APPLICANT, getApplicant);
}

export function* watchGetApplicantOne() {
  yield takeEvery(GET_APPLICANT_ONE, getApplicantOne);
}

export function* watchUpdateApplicant() {
  yield takeEvery(UPDATE_APPLICANT, onUpdateApplicant);
}

export function* watchDeleteApplicant() {
  yield takeEvery(DELETE_APPLICANT, onDeleteApplicant);
}

export function* watchAddNewApplicant() {
  yield takeEvery(ADD_NEW_APPLICANT, onAddNewApplicant);
}

function* applicantSaga() {
  yield all([fork(watchGetApplicant), fork(watchGetApplicantOne), fork(watchDeleteApplicant), fork(watchUpdateApplicant), fork(watchAddNewApplicant)]);
}

export default applicantSaga;
